"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MawidDeltaResponse_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MawidDeltaResponse_Factory = /** @class */ (function () {
    function MawidDeltaResponse_Factory() {
    }
    MawidDeltaResponse_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CASAppId: model.CASAppId,
            HISAppId: model.HISAppId,
            HISSlotID: model.HISSlotID,
        };
        return result;
    };
    MawidDeltaResponse_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CASAppId: model.CASAppId,
            HISAppId: model.HISAppId,
            HISSlotID: model.HISSlotID,
        };
        return result;
    };
    return MawidDeltaResponse_Factory;
}());
exports.MawidDeltaResponse_Factory = MawidDeltaResponse_Factory;
